export default "__VITE_ASSET__gOOQwSgJ__"